var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysFaceMessage = function SvgSysFaceMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0084ff",
    d: "M12 24A12 12 0 0 1 3.515 3.515a12 12 0 0 1 16.97 16.97A11.921 11.921 0 0 1 12 24Zm0-17.6a5.41 5.41 0 0 0-5.6 5.185 5.03 5.03 0 0 0 2.087 4.038V17.6l1.907-1.047a6 6 0 0 0 1.606.218 5.411 5.411 0 0 0 5.6-5.185A5.411 5.411 0 0 0 12 6.4Zm-3.652 6.982 3.062-3.248 1.461 1.521 2.747-1.521-3.06 3.249-1.428-1.522Z",
    "data-name": "Subtra\\xE7\\xE3o 28"
  })));
};
export default SvgSysFaceMessage;